<template>
    <div>
         <div class="body">
             <el-button class="addTours" type="primary"  @click="line = true">+添加抵扣规则</el-button>
            <template>
                <el-table :data="tableData" border  :header-cell-style="tableHeaderColor" style="width: 100%">
                <el-table-column  prop="id"  label="序号" width="80px"></el-table-column>
                <el-table-column  prop="type"  label="抵扣类型" :formatter="types" ></el-table-column>
                <el-table-column  prop="maxValue"  label="抵扣值" ></el-table-column>
                <el-table-column prop="address" label="操作">
                  <template slot-scope="scope">
                      <el-button type="primary" @click.native.prevent="deleteParameter(scope.row)">删除</el-button>
                      <el-button type="primary" @click.native.prevent="updateParameter(scope.row)">修改</el-button>
                  </template>
                </el-table-column>
                </el-table>
            </template>
            <el-dialog title="添加参数"  :visible.sync="line"   width="20%"   :before-close="handleClose">
                <el-form ref="form" :model="form" class="form" label-width="80px">
                    <el-form-item label="抵扣类型:">
                        <el-select v-model="form.type" placeholder="请选择抵扣规则">
                          <el-option  v-for="item in options"  :key="item.value"  :label="item.label"  :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="抵扣值:">
                        <el-input v-model="form.maxValue" placeholder="请输入内容"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="line = false">取 消</el-button>
                    <el-button type="primary" @click="addStoreImg">确 定</el-button>
                </span>
            </el-dialog>
         </div>
    </div>
</template>

  <script>

import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')

    export default {
      data() {
        return {
          tableData: [],
          current:1,
          total:50,
          line:false,
          imageUrl:'',
          form: {
            id:null,
            productId:1,
            type: '',
            maxValue:'',
          },
          file:'',
          url: 'https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/backgroundImg.jpg',
          srcList: [
          'https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/backgroundImg.jpg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
          'https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/qoo_tours/img/2020Y/8M/19D/1597820317411.jpg'
        ],
        options: [{
          value: '1',
          label: '金豆(角)'
        }, {
          value: '2',
          label: '代金券(元)'
        }],
        }
      },
      mounted(){
        this.form.productId = this.productIdx
        this.page(true);
      },
      computed:{
        ...mapState({
            componentType:state=>state.componentType,
            productIdx:state=>state.productId
        })
      },
       methods: {
         ...mapMutations(['addProductId']),

        //商品详情
        storeInfo(row){
            this.addProductId(row.id)
            this.$router.replace('/storeInfo')
        },
    
        handlerUpload: function (e){
            console.log(e)
            //获取选定的文件
            this.file = e.target.files[0];
        },

          //分页
        page(type){
            let that = this
            console.log("来了")
            this.joker.store.deductionOne(this.productIdx).then(res=>{
                console.log(res)
                that.tableData = res.content
            }).catch(res=>{
                console.log(res)
            })
        },

    
        //添加商品
        addStoreImg(){
          this.line = false
          console.log(this.form)

          if(this.form.id == null){
            this.joker.store.addDeduction(this.form).then(res=>{
                console.log(res)
                if(res.success){
                  alert('添加成功')
                  this.page(true);
                }
            }).catch(res=>{
                  console.log(res)
            })
          }else{
            this.joker.store.updateDeduction(this.form).then(res=>{
              console.log(res)
              if(res.success){
                alert('修改成功')
                this.page(true);
              }
            }).catch(res=>{
              console.log(res)
            })
          }
        },
    
        //修改商品信息
        updateParameter(row){
            this.form = row
            this.form.coverFile = row.coverUrl
            this.line =true
        },

        //删除商品信息
        deleteParameter(row){
            console.log(row)
            let that = this
            this.joker.store.deleteDeduction(row.id).then(res=>{
                if(res.success){
                  alert("删除成功")
                 that.page(false);
              }
            }).catch(res=>{

            })
        },

        //抵扣规则
        types(row, column){
        if(row.type==1){
            return '金豆(角)'
          }else{
            return '代金券(元)'
          }
        },
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }){
          if (rowIndex === 0) {
              return 'background-color: #409EFF;color: #fff'
          }
        },
        //添加弹框
        handleClose(done) {
          this.$confirm('确认关闭？')
          .then(_ => {
            done();
            var form ={id:null,productName: '',teamType: '',departCityName: '',characteristic: '',duration:'',price:'',coverFile: ''}
            this.form = form
          })
          .catch(_ => {});
        },

      //图片
      handleAvatarSuccess(res, file) {
        this.form.coverFile = URL.createObjectURL(file.raw);
        this.file = file.raw
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'||'image/png'||'image/jpg'||'image/jpg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
        
      }
    }
  </script>

<style scoped>


.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }


.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.addTours{
    margin-right: 90%;
    margin-bottom: 1%;
}

.page{
    margin-top: 1%;
    padding-bottom: 1%;
}

.imgForm{
  margin-bottom: 2%;
}

.img{
    text-align: center;
    width: 200px;
    height: 200px;
}

.temp{
    text-align: center;
}


</style>


// WEBPACK FOOTER //
// src/components/Store/StoreDeduction.vue